import axios from 'axios'
import { normalize } from 'normalizr'
import CRC32 from 'crc-32'

const apiURL = ''

// Get token from localStorage
const token = ''
// localStorage.getItem ('token')

const axiosInstance = axios.create ({
	baseURL: apiURL,
	headers: {
		'Authorization': `Bearer ${token}`
	},
})

export const API = {
	get: params => {
		API.makeCall ({...params, method: 'get'})
	},
	post: params => {
		API.makeCall ({...params, method: 'post'})
	},
	put: params => {
		API.makeCall ({...params, method: 'put'})
	},
	makeCall: ({ endpoint, mutation, store, method, params, scheme, payload, responseType }) => {
		const { 
			REQUEST: requestMutation, 
			SUCCESS: successMutation, 
			FAILURE: failedMutation 
		} = mutation

		// Execute first mutation (REQUEST)
		store.commit (requestMutation, payload)

		if (!responseType) 
			responseType = 'json'

		// Create axios config and add the parameters
		// in url or in body basing on request method
		let axiosConfig = {
			responseType,
			method
		}

		if (method == 'get') {
			axiosConfig.params = {
				...params
			}
		} else {
			axiosConfig.data = {
				...params
			}
		}

		// Perform network request
		axiosInstance (`${endpoint}`, axiosConfig).then (response => {
			if (response.status === 200) {
				const contentType = response.headers['content-type']
				const isJSON = contentType.includes ('application/json') 
				
				if (isJSON && response.data.success === true) {
					var { response: responseData } = response.data
					if (responseData === null) {
						store.commit (successMutation, [])
						return
					}

					if (scheme != null) {
						const { entities, result: ids } = normalize (responseData, scheme)
						const schemeKey = Array.isArray (scheme) ? scheme[0].key : scheme.key
						// console.log (schemeKey, entities)
						
						responseData = { 
							[schemeKey]: entities [schemeKey], 
							ids,
							payload
						}
					}

					store.commit (successMutation, {
						data: responseData,
						payload
					})
				} else if (isJSON && response.data.success === false) {
					throw new Error (response.error)
				} else {
					const fileName = response.headers['x-file-name']
					store.commit (successMutation, {
						data: response.data,
						payload,
						fileName
					})
				}
			} else {
				throw new Error (response)
			}
		})
			.catch (error => {
				if (error.response && error.response.data && error.response.data.error) {
					store.commit (failedMutation, {
						error: error.response.data.error,
						payload
					})
					return
				}

				const status = (error.response && error.response.status ? error.response.status : 500)
				
				switch (status) {
				case 404:
					error = {
						message: 'Il server non ha risposto correttamente alla richiesta.',
						code: `API/${CRC32.str (requestMutation).toString (16).toUpperCase ().replace ('-', '')}`
					}
					break
				case 500:
					error = {
						message: 'Il server è offline.'
					}
					break
				default: break
				}

				store.commit (failedMutation, {
					error,
					payload
				})
			})
	}
}